import * as Yup from 'yup';

const phoneRegex = /^(07)[02369]\s*(\d{4})\s*(\d{3})$/
const ssnRegex = /^(19|20)?(\d{6}(-|\s)\d{4})$/

export const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email("Email du lämnade var felaktig (exempel@exempel.se)")
        .required("Du måste ange din e-postadress")
        .matches(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/, "Email du lämnade var felaktig (exempel@exempel.se)")
    , phoneNumber: Yup.string()
        .matches(phoneRegex, "Felaktigt angett telefonnummer (Ex. 0712345678)")
        .required("Telefonummer krävs")
    , workStatus: Yup.string()
        .when('stepTwo', {
            is: true,
            then: Yup.string().required("Du ska välja något här")
        })
    , workStatusSince: Yup.string()
        .when('stepTwo', {
            is: true,
            then: Yup.string().required("Ogiltigt datum")
        })
    , income: Yup.number()
        .when('stepTwo', {
            is: true,
            then: Yup.number().required("Inkomst krävs").max(200000, "Kan inte vara över 200 000 kr").min(10000, "Måste vara över 10 000 kr")
        })
    , livingCost: Yup.number()
        .when('stepTwo', {
            is: true,
            then: Yup.number().min(0, "Boendekostnad krävs").max(20000, "Kan inte vara över 20 000 kr")
        })
    , loanPurpose: Yup.string()
        .when(['stepTwo', 'amount', 'oldLoan', 'oldLoanExist'], {
            is: (stepTwo, amount, oldLoan, oldLoanExist) => stepTwo && !oldLoanExist,
            then: Yup.string().required("Du ska välja något här")
        })
    , employer: Yup.string()
        .when(['stepTwo', 'workStatus'], {
            is: (stepTwo, workStatus) => stepTwo && workStatus != "retired" && workStatus != "earlyRetirement" && workStatus != "",
            then: Yup.string().required("Du ska välja något här")
        })
    , employerPhone: Yup.string()
        .when(['stepTwo', 'workStatus'], {
            is: (stepTwo, workStatus) => stepTwo && workStatus != "retired" && workStatus != "earlyRetirement" && workStatus != "",
            then: Yup.string()
                .required("Telefonummer krävs")
        })
    , idNumber: Yup.string()
        .when('stepTwo', {
            is: true,
            then: Yup.string().matches(ssnRegex, "Ogiltigt personnummer").required("Personnummer krävs")
        })
    , homeStatus: Yup.string()
        .when('stepTwo', {
            is: true,
            then: Yup.string().required("Du ska välja något här")
        })
    , civilStatus: Yup.string()
        .when('stepTwo', {
            is: true,
            then: Yup.string().required("Du ska välja något här")
        })
    , children: Yup.number()
        .when('stepTwo', {
            is: true,
            then: Yup.number().required("Du ska välja något här")
        })
    , partnerExist: Yup.bool()
        .when('stepTwo', {
            is: true,
            then: Yup.bool().required("Välj vänligast en")
        })
    , partnerIdNumber: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string().matches(ssnRegex, "Ogiltigt personnummer").required("Personnummer krävs")
        })
    , partnerEmail: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string()
                .email("e-postadressen du lämnade var felaktig (exempel@exempel.se)")
                .required("Du måste ange din e-postadress")
        })
    , partnerPhoneNumber: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string()
                .matches(phoneRegex, "Felaktigt angett telefonnummer (Ex. 0712345678)")
                .required("Telefonummer krävs")
        })
    , partnerChildren: Yup.number()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.number().min(0, "Antal barn krävs").max(10, "Antal barn krävs")
        })
    , partnerEmployer: Yup.string()
        .when(['stepTwo', 'partnerExist', 'partnerWorkStatus'], {
            is: (stepTwo, partnerExist, partnerWorkStatus) => stepTwo && partnerExist && partnerWorkStatus != "retired" && partnerWorkStatus != "earlyRetirement" && partnerWorkStatus != "",
            then: Yup.string().required("Du ska välja något här")
        })
    , partnerEmployerPhone: Yup.string()
        .when(['stepTwo', 'partnerExist', 'partnerWorkStatus'], {
            is: (stepTwo, partnerExist, partnerWorkStatus) => stepTwo && partnerExist && partnerWorkStatus != "retired" && partnerWorkStatus != "earlyRetirement" && partnerWorkStatus != "",
            then: Yup.string()
                .required("Telefonummer krävs")
        })
    , partnerWorkStatus: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string().required("Du ska välja något här")
        })
    , partnerWorkStatusSince: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string().required("Ogiltigt datum")
        })
    , partnerLivingCost: Yup.number()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.number().min(0, "Boendekostnad krävs").max(20000, "Kan inte vara över 20 000 kr")
        })
    , partnerCivilStatus: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string().required("Du ska välja något här")
        })
    , partnerHomeStatus: Yup.string()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.string().required("Du ska välja något här")
        })
    , partnerIncome: Yup.number()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo && partnerExist,
            then: Yup.number().min(0, "Inkomst krävs").max(200000, "Kan inte vara över 200 000 kr").min(10000, "Måste vara över 10 000 kr")
        })
    , repaymentTime: Yup.number()
        .when(['stepTwo', 'partnerExist'], {
            is: (stepTwo, partnerExist) => stepTwo ,
            then: Yup.number().min(0, "Inkomst krävs").max(20, "Kan inte vara över 20 år").min(1, "Måste vara över 0 år")
        })
});